<span #buttonLabel class="button-label">Save</span>
<svg [climbIcon]="icons.checkmark" iconPositionEnd></svg>
